module.exports = __webpack_public_path__ + "static/media/scoreboard.789de343.png";